/** Mock do anúncio como aparece no feed do Instagram. */

import { OBJETIVOS_IMPULSIONAR } from "@shared/meta-ads-boost";
import type { BoostForm } from "@/lib/meta-ads-boost-form";
import { Heart, MessageCircle, Send } from "lucide-react";

export function PreviewAnuncio({ form, username }: { form: BoostForm; username: string | null }) {
  const legenda = form.conteudoTipo === "instagram_post" ? form.media?.caption ?? "" : form.linkAd.message;
  const imagem = form.conteudoTipo === "instagram_post" ? form.media?.thumbUrl ?? null : form.linkAd.imageUrl || null;
  const cta = form.objetivo ? OBJETIVOS_IMPULSIONAR[form.objetivo].ctaLabel : null;
  const conta = username ? `@${username}` : "sua_conta";

  return (
    <div className="space-y-2">
      <div className="mx-auto w-full max-w-[320px] overflow-hidden rounded-[28px] border-[6px] border-neutral-900 bg-white text-neutral-900 shadow-xl dark:bg-neutral-950 dark:text-neutral-100">
        <div className="flex items-center gap-2 px-3 py-2 text-xs">
          <div className="h-7 w-7 rounded-full bg-gradient-to-br from-pink-500 to-yellow-400" />
          <div className="leading-tight">
            <p className="font-semibold">{conta}</p>
            <p className="text-[10px] text-muted-foreground">Patrocinado</p>
          </div>
        </div>
        <div className="aspect-square w-full bg-neutral-200 dark:bg-neutral-800">
          {imagem ? <img src={imagem} alt="" className="h-full w-full object-cover" /> : <div className="flex h-full items-center justify-center text-xs text-muted-foreground">sem imagem</div>}
        </div>
        {cta && (
          <div className="flex items-center justify-between bg-[#3797f0] px-3 py-2 text-xs font-semibold text-white">
            {cta}
            <span>›</span>
          </div>
        )}
        <div className="space-y-1 px-3 py-2">
          <div className="flex gap-3 text-neutral-700 dark:text-neutral-300">
            <Heart className="h-4 w-4" />
            <MessageCircle className="h-4 w-4" />
            <Send className="h-4 w-4" />
          </div>
          <p className="line-clamp-4 text-[12px] leading-snug">
            <span className="font-semibold">{conta}</span> {legenda || <span className="text-muted-foreground">texto do anúncio</span>}
          </p>
          {form.conteudoTipo === "link" && form.linkAd.headline && <p className="text-[12px] font-semibold">{form.linkAd.headline}</p>}
        </div>
      </div>
      <p className="text-center text-xs text-muted-foreground">Prévia aproximada — o Instagram pode mostrar de outro jeito.</p>
    </div>
  );
}
